import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';
import useStyles from './styles';

const ChipHelper = ({ c, className, addFieldInContent }) => {
  const classes = useStyles();
  return (
    <Tooltip title="click to add in text" arrow>
      <Chip
        label={`{{${c.fieldName}}}`}
        size="small"
        mr={3}
        mb={3}
        onClick={() => addFieldInContent(c.fieldName)}
        className={!className ? classes.chip : className === 'brand' ? classes.chipBrand : classes.chipProduct}
      />
    </Tooltip>
  );
};

export default ChipHelper;
